import React, {Component} from "react";
import PageHeaderLayout from "../../layout/PageHeaderLayout";
import {Button, Card, Divider, Popconfirm} from "antd";
import StandardTable from "../../components/StandardTable";
import AreaModifyModal from "./areaModifyModal";
import * as utils from "../../utils/utils";
import * as qiniu from "../../utils/qiniu";
import * as api from "../../api/product_location";
import ProductLocationMapModal from "./map";


class ProductLocationArea extends Component {

    state = {
        modalVisible: false,
        modalRecord: {},
        modalSaving: false,

        mapModalRecord: undefined
    }

    columns = [
        {
            title: '库区名称',
            dataIndex: 'name',
        },
        {
            title: '操作',
            render: (record) => (
                <span>
                    <a onClick={() => this.handleModalOpen(record)}>编辑</a>
                    <Divider type={"vertical"}/>
                    <a onClick={() => this.handleMapModalOpen(record)}>库位图</a>
                    <Divider type={"vertical"}/>
                    <a target={'_blank'} href={'/location/' + record.uuid}>地址</a>
                    <Divider type={"vertical"}/>
                    <Popconfirm title={'是否确认删除'} onConfirm={() => this.handleDelete(record.id)}>
                        <a>删除</a>
                    </Popconfirm>
                </span>
            )
        }
    ]

    dataTable = null

    handleDelete = (areaId) => {
        api.deleteProductLocationArea(areaId).then(() => {
            this.dataTable.fetch()
        })
    }

    handleMapModalOpen = (record) => {
        this.setState({
            mapModalRecord: record
        })
    }

    handleModalOpen = (record = {}) => {
        this.setState({
            modalVisible: true,
            modalRecord: record,
        })
    }

    handleModalSave = async (data) => {
        this.setState({modalSaving: true})
        if (data.image) {
            const file = await this.getImageSize(data.image.file)
            const filePart = {
                file: file.file,
                key: `location/area/${utils.extendFileName(file.file.name)}`,
                putExtra: {}
            }
            const result = await qiniu.upload([filePart], 'location')
            data.image = result[0].key
            data.width = file.width
            data.height = file.height
        }
        api.modifyProductLocationArea(data).then(() => {
            this.dataTable.fetch()
            this.setState({modalSaving: false, modalVisible: false})
        }).catch(() => {
            this.setState({modalSaving: false})
        })
    }

    getImageSize = (file) => {
        return new Promise(function (resolve, reject) {
            let reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = function (theFile) {
                let image = new Image()
                image.src = theFile.target.result
                image.onload = function () {
                    resolve({
                        file: file,
                        width: this.width,
                        height: this.height,
                    })
                }
            }
        })
    }


    render() {
        return (
            <PageHeaderLayout title={'仓库库区'}>
                <Card>
                    <div style={{marginBottom: 10}}>
                        <Button type={'primary'} onClick={() => this.handleModalOpen()}>新增</Button>
                    </div>
                    <StandardTable url={'/api/product/location/area'} rowKey={'id'} columns={this.columns}
                                   ref={ref => this.dataTable = ref}/>
                </Card>
                <AreaModifyModal visible={this.state.modalVisible}
                                 record={this.state.modalRecord}
                                 onCancel={() => this.setState({modalVisible: false})}
                                 handleAdd={this.handleModalSave}
                                 confirmLoading={this.state.modalSaving}
                />
                <ProductLocationMapModal visible={!!this.state.mapModalRecord}
                                         onCancel={() => this.setState({mapModalRecord: undefined})}
                                         record={this.state.mapModalRecord}
                />
            </PageHeaderLayout>
        );
    }
}

export default ProductLocationArea